import React from 'react';
import PropTypes from 'prop-types';

import {TextField} from 'views/components';
import {translate} from 'views/module';

const ActionLogTextbox = (props) => {
  const {
    onSubmit,
  } = props;
  const [message, setMessage] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const submitMessage = async () => {
    const trimmedMessage = message.trim();

    if (!trimmedMessage || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      const saved = await onSubmit(trimmedMessage);

      if (saved) {
        setMessage('');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();
    submitMessage();
  };

  return (
    <TextField
      value={message}
      onChange={setMessage}
      onKeyDown={handleKeyDown}
      fullWidth
      placeholder={translate('case.Detail.ActionLog.Placeholder')}
      autoComplete='off'
      disabled={isSubmitting}
      sx={{
        'width': '100%',
        '& .MuiOutlinedInput-root': {
          'backgroundColor': 'common.white',
          'borderRadius': '4px',
          '& fieldset': {
            'borderStyle': 'dashed',
            'borderColor': '#A8A49E',
          },
        },
        '& .MuiOutlinedInput-input': {
          'px': '16px',
          'py': '10px',
          'fontSize': '11px',
          'lineHeight': '150%',
          'whiteSpace': 'pre',
          'color': '#1A1916',
          'caretColor': '#1A1916',
        },
        '& .MuiOutlinedInput-input::placeholder': {
          'color': '#A8A49E',
          'opacity': 1,
        },
      }}
    />
  );
};

ActionLogTextbox.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default React.memo(ActionLogTextbox);
